import { render } from "./ImageModal2.vue?vue&type=template&id=5019c9e6&scoped=true"
import script from "./ImageModal2.vue?vue&type=script&lang=js"
export * from "./ImageModal2.vue?vue&type=script&lang=js"

import "./ImageModal2.vue?vue&type=style&index=0&id=5019c9e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5019c9e6"]])

export default __exports__